export const environment = {
  baseUrl: 'http://localhost:4200',
	publicBaseUrl: 'https://slaveous.com',
	production: true,
	testEnv: false,
	firebase: {
		apiKey: 'AIzaSyAd1EM4u-m_Fvn2Nb_BJQ0XtN46Q7W90ZQ',
		authDomain: 'slaveous.firebaseapp.com',
		databaseURL: 'https://slaveous.firebaseio.com',
		projectId: 'slaveous',
		storageBucket: 'slaveous.appspot.com',
		messagingSenderId: '963652012004',
		appId: '1:963652012004:web:2456306d96f8cc9ea429f1',
		measurementId: 'G-0J1PFES79S'
	},
	FIREBASE_APPCHECK_DEBUG_TOKEN: null,
	actualVersion: 'V1.0.1.4',
	captcha: '6Lc6sAQrAAAAAGIKtyujmXxfcho2w4r3G56dL16K',
	logging: {
		level: 'warn',
		analytics: true
	}
};
